import React from "react";
import ReactDOM from "react-dom/client";
import { RouterProvider } from "react-router-dom";
import { AuthProvider } from "./context/AuthContext";
import { FilterProvider } from "./context/FilterContext";
import { router } from "./router";
import { installeerHarnessHaak } from "./lib/harness-hook";
import "./styles/global.css";

// Moet vóór React draaien: anders mist het eerste verzoek de testmodus-header.
installeerHarnessHaak();

ReactDOM.createRoot(document.getElementById("root")!).render(
  <React.StrictMode>
    <AuthProvider>
      <FilterProvider>
        <RouterProvider router={router} />
      </FilterProvider>
    </AuthProvider>
  </React.StrictMode>,
);
